import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import clsx from 'clsx'
import { useHifzStream, type WordStatus } from '../hooks/useHifzStream'

// Surah catalogue — name + ayah count.
const SURAHS: { n: number; name: string; ayahs: number }[] = [
  { n: 1, name: 'Al-Fatiha', ayahs: 7 },
  { n: 2, name: 'Al-Baqara', ayahs: 286 },
  { n: 3, name: 'Aal-e-Imran', ayahs: 200 },
  { n: 4, name: 'An-Nisa', ayahs: 176 },
  { n: 5, name: 'Al-Maidah', ayahs: 120 },
  { n: 6, name: 'Al-An\u2019am', ayahs: 165 },
  { n: 7, name: 'Al-A\u2019raf', ayahs: 206 },
  { n: 8, name: 'Al-Anfal', ayahs: 75 },
  { n: 9, name: 'At-Tawbah', ayahs: 129 },
  { n: 10, name: 'Yunus', ayahs: 109 },
  { n: 11, name: 'Hud', ayahs: 123 },
  { n: 12, name: 'Yusuf', ayahs: 111 },
  { n: 13, name: 'Ar-Ra\u2019d', ayahs: 43 },
  { n: 14, name: 'Ibrahim', ayahs: 52 },
  { n: 15, name: 'Al-Hijr', ayahs: 99 },
  { n: 16, name: 'An-Nahl', ayahs: 128 },
  { n: 17, name: 'Al-Isra', ayahs: 111 },
  { n: 18, name: 'Al-Kahf', ayahs: 110 },
  { n: 19, name: 'Maryam', ayahs: 98 },
  { n: 20, name: 'Ta-Ha', ayahs: 135 },
  { n: 21, name: 'Al-Anbiya', ayahs: 112 },
  { n: 22, name: 'Al-Hajj', ayahs: 78 },
  { n: 23, name: 'Al-Mu\u2019minun', ayahs: 118 },
  { n: 24, name: 'An-Nur', ayahs: 64 },
  { n: 25, name: 'Al-Furqan', ayahs: 77 },
  { n: 26, name: 'Ash-Shu\u2019ara', ayahs: 227 },
  { n: 27, name: 'An-Naml', ayahs: 93 },
  { n: 28, name: 'Al-Qasas', ayahs: 88 },
  { n: 29, name: 'Al-\u2019Ankabut', ayahs: 69 },
  { n: 30, name: 'Ar-Rum', ayahs: 60 },
  { n: 31, name: 'Luqman', ayahs: 34 },
  { n: 32, name: 'As-Sajdah', ayahs: 30 },
  { n: 33, name: 'Al-Ahzab', ayahs: 73 },
  { n: 34, name: 'Saba', ayahs: 54 },
  { n: 35, name: 'Fatir', ayahs: 45 },
  { n: 36, name: 'Ya-Sin', ayahs: 83 },
  { n: 37, name: 'As-Saffat', ayahs: 182 },
  { n: 38, name: 'Sad', ayahs: 88 },
  { n: 39, name: 'Az-Zumar', ayahs: 75 },
  { n: 40, name: 'Ghafir', ayahs: 85 },
  { n: 41, name: 'Fussilat', ayahs: 54 },
  { n: 42, name: 'Ash-Shura', ayahs: 53 },
  { n: 43, name: 'Az-Zukhruf', ayahs: 89 },
  { n: 44, name: 'Ad-Dukhan', ayahs: 59 },
  { n: 45, name: 'Al-Jathiyah', ayahs: 37 },
  { n: 46, name: 'Al-Ahqaf', ayahs: 35 },
  { n: 47, name: 'Muhammad', ayahs: 38 },
  { n: 48, name: 'Al-Fath', ayahs: 29 },
  { n: 49, name: 'Al-Hujurat', ayahs: 18 },
  { n: 50, name: 'Qaf', ayahs: 45 },
  { n: 51, name: 'Adh-Dhariyat', ayahs: 60 },
  { n: 52, name: 'At-Tur', ayahs: 49 },
  { n: 53, name: 'An-Najm', ayahs: 62 },
  { n: 54, name: 'Al-Qamar', ayahs: 55 },
  { n: 55, name: 'Ar-Rahman', ayahs: 78 },
  { n: 56, name: 'Al-Waqi\u2019ah', ayahs: 96 },
  { n: 57, name: 'Al-Hadid', ayahs: 29 },
  { n: 58, name: 'Al-Mujadilah', ayahs: 22 },
  { n: 59, name: 'Al-Hashr', ayahs: 24 },
  { n: 60, name: 'Al-Mumtahanah', ayahs: 13 },
  { n: 61, name: 'As-Saff', ayahs: 14 },
  { n: 62, name: 'Al-Jumu\u2019ah', ayahs: 11 },
  { n: 63, name: 'Al-Munafiqun', ayahs: 11 },
  { n: 64, name: 'At-Taghabun', ayahs: 18 },
  { n: 65, name: 'At-Talaq', ayahs: 12 },
  { n: 66, name: 'At-Tahrim', ayahs: 12 },
  { n: 67, name: 'Al-Mulk', ayahs: 30 },
  { n: 68, name: 'Al-Qalam', ayahs: 52 },
  { n: 69, name: 'Al-Haqqah', ayahs: 52 },
  { n: 70, name: 'Al-Ma\u2019arij', ayahs: 44 },
  { n: 71, name: 'Nuh', ayahs: 28 },
  { n: 72, name: 'Al-Jinn', ayahs: 28 },
  { n: 73, name: 'Al-Muzzammil', ayahs: 20 },
  { n: 74, name: 'Al-Muddathir', ayahs: 56 },
  { n: 75, name: 'Al-Qiyamah', ayahs: 40 },
  { n: 76, name: 'Al-Insan', ayahs: 31 },
  { n: 77, name: 'Al-Mursalat', ayahs: 50 },
  { n: 78, name: 'An-Naba', ayahs: 40 },
  { n: 79, name: 'An-Nazi\u2019at', ayahs: 46 },
  { n: 80, name: 'Abasa', ayahs: 42 },
  { n: 81, name: 'At-Takwir', ayahs: 29 },
  { n: 82, name: 'Al-Infitar', ayahs: 19 },
  { n: 83, name: 'Al-Mutaffifin', ayahs: 36 },
  { n: 84, name: 'Al-Inshiqaq', ayahs: 25 },
  { n: 85, name: 'Al-Buruj', ayahs: 22 },
  { n: 86, name: 'At-Tariq', ayahs: 17 },
  { n: 87, name: 'Al-A\u2019la', ayahs: 19 },
  { n: 88, name: 'Al-Ghashiyah', ayahs: 26 },
  { n: 89, name: 'Al-Fajr', ayahs: 30 },
  { n: 90, name: 'Al-Balad', ayahs: 20 },
  { n: 91, name: 'Ash-Shams', ayahs: 15 },
  { n: 92, name: 'Al-Layl', ayahs: 21 },
  { n: 93, name: 'Ad-Duha', ayahs: 11 },
  { n: 94, name: 'Ash-Sharh', ayahs: 8 },
  { n: 95, name: 'At-Tin', ayahs: 8 },
  { n: 96, name: 'Al-\u2019Alaq', ayahs: 19 },
  { n: 97, name: 'Al-Qadr', ayahs: 5 },
  { n: 98, name: 'Al-Bayyinah', ayahs: 8 },
  { n: 99, name: 'Az-Zalzalah', ayahs: 8 },
  { n: 100, name: 'Al-\u2019Adiyat', ayahs: 11 },
  { n: 101, name: 'Al-Qari\u2019ah', ayahs: 11 },
  { n: 102, name: 'At-Takathur', ayahs: 8 },
  { n: 103, name: 'Al-\u2019Asr', ayahs: 3 },
  { n: 104, name: 'Al-Humazah', ayahs: 9 },
  { n: 105, name: 'Al-Fil', ayahs: 5 },
  { n: 106, name: 'Quraysh', ayahs: 4 },
  { n: 107, name: 'Al-Ma\u2019un', ayahs: 7 },
  { n: 108, name: 'Al-Kawthar', ayahs: 3 },
  { n: 109, name: 'Al-Kafirun', ayahs: 6 },
  { n: 110, name: 'An-Nasr', ayahs: 3 },
  { n: 111, name: 'Al-Masad', ayahs: 5 },
  { n: 112, name: 'Al-Ikhlas', ayahs: 4 },
  { n: 113, name: 'Al-Falaq', ayahs: 5 },
  { n: 114, name: 'An-Nas', ayahs: 6 },
]

export default function MemorizePage() {
  const [surah, setSurah] = useState<number>(() => {
    const saved = localStorage.getItem('hifz_surah')
    return saved ? Number(saved) : 1
  })
  const [errorMsg, setErrorMsg] = useState<string | null>(null)

  const { state, meta, statuses, setStatuses, pointer, level, elapsed, start, stop, close } =
    useHifzStream({ onError: setErrorMsg })

  const surahInfo = useMemo(() => SURAHS.find((s) => s.n === surah)!, [surah])

  const onPick = useCallback((n: number) => {
    setSurah(n)
    localStorage.setItem('hifz_surah', String(n))
  }, [])

  const onStart = useCallback(async () => {
    setErrorMsg(null)
    await start(surah)
  }, [start, surah])

  const peek = useCallback(
    (index: number) => {
      setStatuses((prev) => {
        const next = [...prev]
        if (next[index] === 'hidden' || next[index] === 'missed') {
          next[index] = 'peeked'
        }
        return next
      })
    },
    [setStatuses]
  )

  const resetSession = useCallback(() => {
    close()
    setErrorMsg(null)
  }, [close])

  // Group words by ayah for rendering
  const grouped = useMemo(() => {
    if (!meta) return [] as { ayah: number; indices: number[] }[]
    const out: { ayah: number; indices: number[] }[] = []
    let cur: { ayah: number; indices: number[] } | null = null
    for (const w of meta.words) {
      if (!cur || cur.ayah !== w.ayah) {
        cur = { ayah: w.ayah, indices: [] }
        out.push(cur)
      }
      cur.indices.push(w.index)
    }
    return out
  }, [meta])

  // Auto-scroll to keep the current pointer visible
  const contentRef = useRef<HTMLDivElement | null>(null)
  useEffect(() => {
    if (state !== 'listening' || !meta) return
    const idx = pointer
    if (idx < 0 || idx >= meta.words.length) return
    const el = contentRef.current?.querySelector<HTMLElement>(
      `[data-word-idx="${idx}"]`
    )
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
  }, [pointer, state, meta])

  const revealedCount = statuses.filter((s) => s === 'revealed').length
  const missedCount = statuses.filter((s) => s === 'missed').length
  const peekedCount = statuses.filter((s) => s === 'peeked').length
  const total = meta?.words.length ?? 0
  const listening = state === 'listening'

  const mmss = (s: number) =>
    `${String(Math.floor(s / 60)).padStart(2, '0')}:${String(s % 60).padStart(2, '0')}`

  const currentAyah =
    meta && pointer < meta.words.length ? meta.words[pointer].ayah : null

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 py-6 pb-40">
      {/* Header */}
      <div className="flex items-end justify-between mb-4">
        <div>
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 dark:text-white">
            Memorize
          </h1>
          <p className="text-sm text-gray-500 dark:text-gray-400 mt-0.5">
            Recite from memory. Words appear as you say them.
          </p>
        </div>
        {meta && (
          <div className="text-right text-xs text-gray-500 dark:text-gray-400 tabular-nums">
            <div>
              {meta.surahName}
            </div>
            {currentAyah && (
              <div>
                Ayah {currentAyah} / {meta.ayahEnd}  ·  {pointer} / {total} words
              </div>
            )}
          </div>
        )}
      </div>

      {/* Surah picker — only before a session starts */}
      {!meta && (
        <div className="card p-5 space-y-4 mb-6">
          <div>
            <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">
              Surah
            </label>
            <select
              className="w-full bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg px-3 py-2 text-gray-900 dark:text-white"
              value={surah}
              onChange={(e) => onPick(Number(e.target.value))}
            >
              {SURAHS.map((s) => (
                <option key={s.n} value={s.n}>
                  {s.n}. {s.name} ({s.ayahs} ayahs)
                </option>
              ))}
            </select>
          </div>
          <button
            type="button"
            onClick={onStart}
            disabled={state === 'connecting'}
            className="btn-primary text-sm py-2 px-6 w-full"
          >
            {state === 'connecting' ? 'Loading…' : `Begin ${surahInfo.name}`}
          </button>
          {errorMsg && (
            <div className="text-sm text-red-500">{errorMsg}</div>
          )}
          <div className="text-xs text-gray-500 dark:text-gray-400 pt-2 border-t border-gray-100 dark:border-gray-800">
            Tap <b>Begin</b>, wait for the page to appear, then recite from ayah 1
            straight through. Each word lights up as the mic hears it. If you
            pause, the page waits. Tap the stop button when done.
          </div>
        </div>
      )}

      {/* Target area */}
      {meta && (
        <div
          ref={contentRef}
          className="card p-6 sm:p-10 mb-6 bg-white dark:bg-gray-900"
        >
          <div className="text-xs uppercase tracking-wider text-gray-400 dark:text-gray-500 text-center mb-6">
            {meta.surahName} · ayah {meta.ayahStart}–{meta.ayahEnd}
          </div>

          <div dir="rtl" className="space-y-4">
            {grouped.map((group) => (
              <div key={group.ayah} className="leading-[3.25rem] text-center">
                {group.indices.map((idx) => {
                  const w = meta.words[idx]
                  const status = statuses[idx]
                  const isCurrent = idx === pointer && listening
                  return (
                    <WordSlot
                      key={idx}
                      index={idx}
                      text={w.text}
                      status={status}
                      isCurrent={isCurrent}
                      onPeek={() => peek(idx)}
                    />
                  )
                })}
                <span className="inline-block mx-2 text-gray-300 dark:text-gray-700 text-2xl align-middle select-none">
                  ۝{toArabicNumerals(group.ayah)}
                </span>
              </div>
            ))}
          </div>

          {/* Stats footer */}
          {(revealedCount > 0 || missedCount > 0 || peekedCount > 0) && (
            <div className="flex justify-center gap-6 pt-6 mt-6 border-t border-gray-100 dark:border-gray-800 text-xs text-gray-500 dark:text-gray-400">
              <div>
                <span className="text-emerald-500 font-semibold">{revealedCount}</span> earned
              </div>
              {missedCount > 0 && (
                <div>
                  <span className="text-amber-500 font-semibold">{missedCount}</span> missed
                </div>
              )}
              {peekedCount > 0 && (
                <div>
                  <span className="text-yellow-500 font-semibold">{peekedCount}</span> peeked
                </div>
              )}
            </div>
          )}
        </div>
      )}

      {/* Floating mic dock — always visible while session active */}
      <AnimatePresence>
        {meta && (
          <motion.div
            initial={{ y: 80, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 80, opacity: 0 }}
            className="fixed bottom-4 left-0 right-0 z-40 flex justify-center pointer-events-none"
          >
            <div className="pointer-events-auto bg-white/95 dark:bg-gray-900/95 backdrop-blur border border-gray-200 dark:border-gray-800 rounded-full shadow-xl px-4 py-2 flex items-center gap-4">
              <button
                type="button"
                onClick={listening ? stop : state === 'ended' ? onStart : stop}
                disabled={state === 'connecting' || state === 'processing'}
                className={clsx(
                  'relative w-14 h-14 rounded-full flex items-center justify-center text-white',
                  listening
                    ? 'bg-gradient-to-br from-red-500 to-red-600'
                    : 'bg-gradient-to-br from-emerald-400 to-emerald-600',
                  (state === 'connecting' || state === 'processing') && 'opacity-50 cursor-not-allowed'
                )}
                style={
                  listening
                    ? { boxShadow: `0 0 ${16 + level * 30}px rgba(239,68,68,${0.3 + level * 0.5})` }
                    : undefined
                }
                aria-label={listening ? 'Stop' : 'Start reciting'}
              >
                {listening ? (
                  <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
                    <rect x="6" y="6" width="12" height="12" rx="2" />
                  </svg>
                ) : (
                  <svg
                    className="w-6 h-6"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <rect x="9" y="3" width="6" height="12" rx="3" />
                    <path d="M5 11a7 7 0 0014 0M12 18v3" />
                  </svg>
                )}
              </button>

              <div className="min-w-[10rem] pr-2">
                <div className="text-xs font-medium text-gray-700 dark:text-gray-200 tabular-nums">
                  {state === 'connecting' && 'Loading surah…'}
                  {state === 'listening' && `Listening  ${mmss(elapsed)}`}
                  {state === 'processing' && 'Finalizing…'}
                  {state === 'ended' && 'Session ended'}
                  {state === 'error' && 'Error'}
                  {state === 'idle' && 'Ready'}
                </div>
                <div className="mt-1 h-1 w-full bg-gray-100 dark:bg-gray-800 rounded-full overflow-hidden">
                  <motion.div
                    className="h-full bg-emerald-500"
                    initial={{ width: 0 }}
                    animate={{
                      width: `${total === 0 ? 0 : (revealedCount / total) * 100}%`,
                    }}
                    transition={{ type: 'spring', stiffness: 120, damping: 20 }}
                  />
                </div>
              </div>

              <button
                type="button"
                onClick={resetSession}
                className="text-xs text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 px-2"
              >
                End
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {errorMsg && meta && (
        <div className="fixed top-20 left-1/2 -translate-x-1/2 text-sm text-red-500 bg-white/95 dark:bg-gray-900/95 px-4 py-2 rounded-lg shadow-lg z-50">
          {errorMsg}
        </div>
      )}
    </div>
  )
}

function WordSlot({
  index,
  text,
  status,
  isCurrent,
  onPeek,
}: {
  index: number
  text: string
  status: WordStatus
  isCurrent: boolean
  onPeek: () => void
}) {
  if (status === 'revealed') {
    return (
      <motion.span
        data-word-idx={index}
        initial={{ opacity: 0, y: 4, filter: 'blur(6px)' }}
        animate={{ opacity: 1, y: 0, filter: 'blur(0px)' }}
        transition={{ duration: 0.2 }}
        className={clsx(
          'arabic-text inline-block mx-1.5 text-gray-900 dark:text-white align-middle',
          isCurrent && 'text-emerald-600 dark:text-emerald-400'
        )}
      >
        {text}
      </motion.span>
    )
  }
  if (status === 'peeked') {
    return (
      <span
        data-word-idx={index}
        className="arabic-text inline-block mx-1.5 text-yellow-600 dark:text-yellow-400 align-middle"
      >
        {text}
      </span>
    )
  }
  const isMissed = status === 'missed'
  return (
    <button
      type="button"
      data-word-idx={index}
      onClick={onPeek}
      className={clsx(
        'inline-block mx-1.5 align-middle select-none rounded-md transition-all',
        isMissed
          ? 'bg-red-100/60 dark:bg-red-900/30 border-b-2 border-red-400 dark:border-red-500'
          : 'bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700',
        isCurrent && 'ring-2 ring-emerald-400 dark:ring-emerald-500 animate-pulse'
      )}
      style={{
        width: `${Math.max(1.5, text.length * 0.55)}rem`,
        height: '2rem',
      }}
      aria-label={isMissed ? 'Missed word — tap to peek' : 'Hidden word — tap to peek'}
    />
  )
}

function toArabicNumerals(n: number): string {
  const digits = '٠١٢٣٤٥٦٧٨٩'
  return String(n)
    .split('')
    .map((d) => digits[Number(d)] || d)
    .join('')
}
